import { deleteDoc, addDoc, collection, updateDoc, arrayUnion,arrayRemove, CollectionReference, doc, DocumentData, DocumentReference, enableIndexedDbPersistence, Firestore, getDoc, getDocs, initializeFirestore, query, setDoc, where, getFirestore} from 'firebase/firestore';
import { FirebaseApp, initializeApp, getApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getStorage, ref, uploadBytes, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";

import "../http/HttpService";
import HttpService from "../http/HttpService";
import { v4 } from 'uuid';

export default (firebaseConfig, configCredentials) => {
    let firebaseApp;
    try {
        firebaseApp = getApp(firebaseConfig.appId)
    } catch (e) {
        firebaseApp = initializeApp(firebaseConfig, firebaseConfig.appId);
    }

    const fireStore = getFirestore(firebaseApp);
    const storage = getStorage(firebaseApp);

    return {
        store: fireStore,
        config: firebaseConfig,
        credentials: configCredentials,

        async assign(chat, user) {
            const basePath = chat.clientId.toString() + '/' + chat.customerId.toString();
            const chatDocument = doc(fireStore,basePath);
            const messageCollection = collection(fireStore,basePath + '/messages' );
            const chatAgentHistoryCollection = collection(fireStore,basePath + '/chatAgentHistory' );
            const lastMessageTimestampDocument = doc(fireStore, basePath + '/highRefreshChatInfos/lastMessageTimestamp');


            if (chat.status === "open" || chat.status === "processed") {
                await updateDoc(chatDocument, {
                    lastStatusUpdateTimestamp: Date.now(),
                    fullEmployeeName: user.name,
                    status: 'processed',
                    userId: user.id,
                });

                await addDoc(chatAgentHistoryCollection, {
                    chatagent: user.id,
                    fullChatagentName: user.name,
                    timeOfContact: Date.now(),
                });

                await addDoc(messageCollection, {
                    messageId: v4(),
                    senderId: user.id,
                    receiverId: "",
                    fullEmployeeName: user.name,
                    fullCustomerName: "",
                    messageText: "Ein Mitarbeiter ist nun im Chat 👍",
                    messageType: "service",
                    source: "service",
                    authorType: "service",
                    timestamp: Date.now(),
                    timestampHumanReadable: moment().format("DD.MM.YYYY HH:mm")
                });

                await updateDoc(lastMessageTimestampDocument, {
                    lastMessageTimestamp: Date.now(),
                });

            } else {
                await updateDoc(chatDocument, {
                    lastStatusUpdateTimestamp: Date.now(),
                    status: 'open',
                });
            }
        },

        async setReadOnly(chat, user) {
            const basePath = chat.clientId.toString() + '/' + chat.customerId.toString();
            const chatDocument = doc(fireStore, basePath);
            if (!this.hasWatchers(chat, user)) {
                await updateDoc(chatDocument, {
                    watchers: arrayUnion(user.id)
                })
            }
        },

        async unsetReadOnly(chat, user) {
            const basePath = chat.clientId.toString() + '/' + chat.customerId.toString();
            const chatDocument = doc(fireStore, basePath);
            await updateDoc(chatDocument, {
                watchers: arrayRemove(user.id)
            });
        },

        hasWatchers(chat, user) {
            if (chat.watchers) {
                return chat.watchers.indexOf(user.id) !== -1
            }
            return false;
        },

        async updateChatGroupId(chat, groupId) {
            const basePath = chat.clientId.toString() + '/' + chat.customerId.toString();
            const chatDocument = doc(fireStore, basePath);

            if (chat.status !== 'processed') {
                await updateDoc(chatDocument, {
                    groupId: groupId,
                });
            }
        },

        async storeFile(clientId, customerId, fileData) {
            return new Promise(function (resolve, reject) {
                const filename = moment.now() + fileData.ext;
                const storageRef = ref(storage, clientId + '/' + customerId + '/' + filename);
                const uploadTask = uploadBytesResumable(storageRef, fileData.object);

                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case 'paused':
                                console.log('Upload is paused');
                                break;
                            case 'running':
                                console.log('Upload is running');
                                break;
                        }
                    },
                    (error) => {
                        console.error(error);
                        reject();
                    },
                    () => {
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            console.log('File available at', downloadURL);
                            resolve({
                                downloadURL,
                                filename
                            });
                        });
                    }
                );
            });
        },

        async createMessage(clientId, customerId, data) {
            const basePath = clientId + '/' + customerId;
            const chatDocument = doc(fireStore, basePath);
            const messageCollection = collection(fireStore, basePath + '/messages');
            const lastMessageTimestampDocument = doc(fireStore, basePath + '/highRefreshChatInfos/lastMessageTimestamp');
            const heartBeatDocument = doc(fireStore, basePath + '/highRefreshChatInfos/heartbeat');

            await addDoc(messageCollection,data);
            await updateDoc(lastMessageTimestampDocument, {
                lastMessageTimestamp: Date.now()
            })

            const document = await getDoc(heartBeatDocument);
            if (document.exists && document.data().heartbeat) {
                const heartbeat = moment(document.data().heartbeat);
                //send push only if customers heartbeat is > 5 , so chat is not open in app
                if (moment().diff(heartbeat, 'seconds') > 5) {
                    HttpService.createPushMessage(clientId, customerId, data);
                }
            } else if (!document.data().heartbeat) {
                //if no heartbeat exists send push at all
                HttpService.createPushMessage(clientId, customerId, data);
            }
        },

        async deleteMessage(clientId, customerId, message) {
            const basePath = clientId + '/' + customerId;
            const messageCollectionPath = basePath + '/messages';
            const messageCollection = collection(fireStore, messageCollectionPath);

            const q = query(messageCollection, where("timestamp", "==", message.timestamp), where('messageId', '==', message.messageId));

            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((document) => {
                if (message.messageType === 'image') {
                    const storageRef = ref(storage, basePath + '/' + message.fileName);
                    deleteObject(storageRef);
                }
                updateDoc(doc(fireStore ,messageCollectionPath + '/' + document.id),{
                        fullCustomerName: '',
                        fullEmployeeName: '',
                        messageText: '✖️ Diese Nachricht wurde gelöscht.',
                        messageType: 'text',
                        messageWasDeleted: true
                    });
                //deleteDoc(doc(fireStore ,messageCollectionPath + '/' + document.id))
            });
        },

        async updateTypingState(clientId, customerId, state) {
            const basePath = clientId + '/' + customerId;
            const agentIsTypingDocument = doc(fireStore, basePath + '/highRefreshChatInfos/agentIsTyping');

            await updateDoc(agentIsTypingDocument, {
                agentIsTyping: state,
            });
        },

        createNewChat(customerId, clientId, customerName) {

            return new Promise((resolve, reject) => {
                HttpService.getHashedClientIdCustomerId(customerId, clientId).then(async (response) => {

                    const hashedCustomerId = response.data.hashedCustomerId;
                    const hashedClientId = response.data.hashedClientId;
                    const chatDocumentRef = doc(fireStore, hashedClientId + '/' + hashedCustomerId);
                    const agentIsTypingDocument = doc(fireStore, hashedClientId + '/' + hashedCustomerId + '/highRefreshChatInfos/agentIsTyping' );
                    const customerIsTypingDocument = doc(fireStore, hashedClientId + '/' + hashedCustomerId + '/highRefreshChatInfos/customerIsTyping' );
                    const messageUpdatedDocument = doc(fireStore, hashedClientId + '/' + hashedCustomerId + '/highRefreshChatInfos/lastMessageTimestamp' );
                    const document = await getDoc(chatDocumentRef);

                    let messages =
                        {
                            "opened": "Der Chat wurde eröffnet und befindet sich im Gesamteingang. Zur Bearbeitung bitte zuweisen.",
                            "reopened": "Der Chat wurde erneut eröffnet und befindet sich im Gesamteingang. Zur Bearbeitung bitte zuweisen.",
                            "already_assigned": "Der Chat ist bereits einem anderen Mitarbeiter zugewiesen: ",
                            "exists": "Der Chat existiert bereits in der Liste offener Chats!"
                        };

                    if (document.exists && document.data()) {
                        // Update if exists
                        switch (document.data().status) {
                            case 'open':
                                console.log("Firebase document data", document.data());
                                return resolve({
                                    "status": "failure",
                                    "message": messages["exists"]
                                });
                            case 'processed':
                                return resolve(
                                    {
                                        "status": "failure",
                                        "message": messages["already_assigned"] + document.data().fullEmployeeName
                                    });
                            case 'closed':
                                await updateDoc(chatDocumentRef, {
                                    status: "open",
                                    lastStatusUpdateTimestamp: Date.now(),
                                    userId: "",
                                    groupId: "",
                                });
                                return resolve(
                                    {
                                        "status": "success",
                                        "message": messages["reopened"]
                                    });
                        }
                    } else {
                        await setDoc(chatDocumentRef,{
                            userId: "",
                            customerId: hashedCustomerId,
                            clientId: hashedClientId,
                            lastStatusUpdateTimestamp: Date.now(),
                            fullCustomerName: customerName,
                            status: "open",
                            groupId: "",
                        });
                        await setDoc(agentIsTypingDocument, {
                            agentIsTyping: false,
                        })
                        await setDoc(customerIsTypingDocument, {
                            customerIsTyping: false,
                        })
                        await setDoc(messageUpdatedDocument, {
                            lastMessageTimestamp: 0,
                        })
                        return resolve({
                            "status": "success",
                            "message": messages["opened"]
                        });
                    }
                });
            });
        }
    };
}
